<template>
    <div lang="en" class="form-group row centix-vue-textinput" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
        <form-label :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
        <span :class="inputCssClass" class="holder-span">
          <div class="row">
            <div class="col">
               <input
                  ref="input"
                  type="number"
                  :step="step"
                  pattern="[0-9]"
                  class="form-control input-item"
                  :min="min"
                  :max="max"
                  :class="{ filled : hasValue, required : showRequiredClass }"
                  v-model.number="innervalue"
                  @input="onChange"
                  @keydown="onKeyDown"
                  @keyup.esc="$event.target.blur()"
                  @blur="onBlur"
                  @keyup.enter="onReturn"
                  :placeholder="placeholder"
                  :disabled="!isEnabled">
            </div>
            <div class="col-auto pl-0" v-if="showStepper">
              <a :class="{ 'disabled' : !isEnabled }" class="btn btn-outline-primary mr-3" style="min-width:5em" @click="decreaseQuantity" href="javascript:void(0)">-</a>
              <a :class="{ 'disabled' : !isEnabled }" class="btn btn-outline-primary" style="min-width:5em" @click="increaseQuantity" href="javascript:void(0)">+</a>
            </div> 
          </div>
       

          <!-- <a class="clear-button" v-if="hasValue && isEnabled" v-on:mousedown.prevent="clearForm()"></a> -->
        </span>
        <div class="model-state-error col-12">
          {{ validationError }}
        </div>
    </div>
</template>
<script>
import FormMixin from './formitem.js';

export default {
  mixins: [FormMixin],
  props: {
    min: Number,
    max: Number,
    step: {
      type: Number,
      default: 1
    },
    showStepper: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      innervalue: '',
    };
  },
  mounted () {
    this.innervalue = this.value;
  },
  methods: {
    clearForm: function () {
      this.$emit('change', '');
    },
    onChange: function (e) {
      //getNumberOrNull returns NULL if this.innervalue is not a number
      let val = getNumberOrNull(this.innervalue);
      
      //only checkAndEmit if val is a number      
      if (val !== null) this.checkAndEmit(val);
    },
    onBlur () {
      this.convert();
      this.$emit('on-blur', this);
    },
    convert () {
      let val = getNumberOrNull(this.innervalue);
      
      if (val && this.step && this.step !== 1) {
        let decimal = getDecimal(this.step);
        val = parseFloat(val.toFixed(decimal));
        this.innervalue = formatWithDecimal(val, decimal);
      }
      this.checkAndEmit(val);
      // this.$emit('change', val);
      // this.emitFormChange();
    },
    checkAndEmit (value) {
      if (this.value !== value) {
        this.$emit('change', value);
        this.emitFormChange();
      }
    },
    onKeyDown(event) {
      if (this.step === 1) {
        if (isDotOrComma(event)) event.preventDefault();
      }
    },
    decreaseQuantity () {
      if ((this.value - 1 >= this.min)|| !this.min) {
        this.checkAndEmit(this.value - 1);
      }
    },
    increaseQuantity () {
      if(this.value >= this.max){
        return;
      }
      if ((this.value + 1 <= this.max)|| !this.max) {
        this.checkAndEmit(this.value + 1);
      }
    },
  },
  watch: {
    value () {
      this.innervalue = (this.value === null) ? ' ' : this.value; // fix for NaN. Otherwise the input is not reset.
    }
  },
  computed: {
    hasValue () {
      return this.innervalue != null && (this.innervalue.toString().trim().length > 0);
    },
    showRequiredClass () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    }
  }
};

const getNumberOrNull = (value) => {
  let val = parseFloat(value);
  return (!Number.isNaN(val)) ? val : null;
};
const getDecimal = (step) => {
  if (step) {
    if (step === 1) return 0;
    return step.toString().split(".")[1].length;
  }
  return 0;
};
const formatWithDecimal = (val, decimal) => {
  return val.toFixed(decimal);
};
const isDotOrComma = (event) => {
  let keys = ['.', ','];
  return keys.some(x => x === event.key);
};

</script>
<style lang="scss" scoped>
@import 'styles/settings.scss';
.centix-vue-textinput {
  span.holder-span {
    position: relative;
    display: block;
  }
  .clear-button {
    position: absolute;
    right: 15px;
    top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
  }
  &:not(.disabled) {
  .input-item {
    padding: 6px;
      &.required {
        border: 1px solid red;
      }
      &.filled {
        border: 1px solid #80bdff;
      }
    }
  }
  .model-state-error {
    color: $error;
  }
}
</style>
